/** The category only the note's allowance action creates (wave 2, R-b); no picker offers it. */
export const FLAT_RATE_CATEGORY = 'flat-rate-allowance';

/**
 * An allowance line: the server refuses to edit it (`CATEGORY_RESERVED`); only Gestione or an
 * approver removes it from its note, with a reason (decision 203).
 */
export function isAllowanceLine(expense: { readonly category?: string | null }): boolean {
  return expense.category === FLAT_RATE_CATEGORY;
}
